import React, { useState, useEffect, Fragment } from 'react';
import styles from './wealth-countries.module.scss';
import { countriesData, totalData } from '../../data/data-wealth-countries';
import { formatNumberWithDot } from '../../utils/utils';
import CountryFlag from '../common/countryFlag/country-flag';
import ProgressBar from '../common/progressBarNeg/progress-bar-neg.module';
import SelectDropdown from '../common/selectDropdown/select-dropdown';
import IconSort from '../common/icon/icon-sort';
import ReverseIconSort from '../common/icon/reverse-icon-sort';

const options = [
  { label: "Millionaires (USD 1m+)", value: "millionaires" },
  { label: "Centi-millionaires (USD 100m+)", value: "centiMillionaires" },
  { label: "Billionaires (USD 1bn+)", value: "billionaires" },
  { label: "Millionaire growth (%) 2013 to 2023", value: "wealthGrowth" },
];

const WealthCountries = () => {

  const [sortColumn, setSortColumn] = useState("millionaires");
  // const [display, setDisplay] = useState();
  const [countryCount, setCountryCount] = useState(1);
  const [centiMilCount, setCentiMilCount] = useState(1);
  const [milCount, setMilCount] = useState(1);
  const [bilCount, setBilCount] = useState(1);
  const [wealthGrowthCount, setWealthGrowthCount] = useState(1);
  // const [numOfCitiesShow, setNumOfCitiesShow] = useState(10);
  // const [hideList, setHideList] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      // Check if the width has actually changed and it's not just a mobile browser adjusting the height
      if (window.innerWidth !== windowWidth) {
        setWindowWidth(window.innerWidth); // Update the width

        if (window.innerWidth < 799) {
          setSortColumn('millionaires');
        } else {
          // Set to other value or keep the current value
          // setSelection('otherValue');
        }
      }
    };

    // Set the initial state based on current window size
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => window.removeEventListener('resize', handleResize);
  }, [windowWidth]); // Dependency on windowWidth to update when it changes




  const handleOptionSelect = (option) => {
    // setSelectedOption(option);
    setSortColumn(option.value);
    // setDisplay(-1);
  };

  const handleSort = (columnName) => {
    switch (columnName) {
      case 'country':
        (countryCount === 1) ? setCountryCount(-1) : setCountryCount(1);
        break;
      case 'millionaires':
        (milCount === 1) ? setMilCount(-1) : setMilCount(1);
        break;
      case 'centiMillionaires':
        (centiMilCount === 1) ? setCentiMilCount(-1) : setCentiMilCount(1);
        break;
      case 'billionaires':
        (bilCount === 1) ? setBilCount(-1) : setBilCount(1);
        break;
      case 'wealthGrowth':
        (wealthGrowthCount === 1) ? setWealthGrowthCount(-1) : setWealthGrowthCount(1);
        break;
      default:
        break;
    }

    setSortColumn(columnName);
    // setDisplay(-1);

  };

  const reverseSortNum = (columnName, count) => {
    if (count === 1) {
      return countriesData.sort((a, b) => b[columnName] - a[columnName]);
    }
    return countriesData.sort((a, b) => a[columnName] - b[columnName]);
  }

  const handleSortingOptions = (columnName) => {
    switch (columnName) {
      case 'country':
        return (countryCount === 1) ?
          countriesData.sort((a, b) => b[columnName].localeCompare(a[columnName]))
          : countriesData.sort((a, b) => a[columnName].localeCompare(b[columnName]));
      case 'millionaires':
        return reverseSortNum(columnName, milCount);
      case 'centiMillionaires':
        return reverseSortNum(columnName, centiMilCount);
      case 'billionaires':
        return reverseSortNum(columnName, bilCount);
      case 'wealthGrowth':
        return reverseSortNum(columnName, wealthGrowthCount);
      default:
        break;
    }
  }


  const sortedData = sortColumn
    ? handleSortingOptions(sortColumn)
    : countriesData;

  // const handleMobileRowClick = (index) => {
  //   setDisplay(index);
  // }

  // const handleShowHideList = () => {
  //   setHideList(!hideList);
  //   setNumOfCitiesShow(numOfCitiesShow === 10 ? `${sortedData.length}` : 10);
  // };


  return (
    <>
      <h3 className="mb-5">Top 10 Wealthiest Countries in Africa</h3>
      <div className={`d-md-none ${styles.sortMobileWrapper}`}>
        <div className={styles.sortTitle}>Sort by</div>
        <SelectDropdown options={options} onSelect={handleOptionSelect} />
      </div>
      <table className={`chartTable ${styles.overviewChartTable}`} >
        <thead>
          <tr className={`d-none d-md-table-row ${styles.sortColumnTitle}`}>

            <th className="no-border-bottom" colSpan="1"></th>
            <th className="text-center" colSpan="3" ><strong>WEALTH BAND</strong></th>
            <th className="no-border-bottom" colSpan="1"></th>
          </tr>
          <tr>
            <th
              className={`text-left ${styles.cellHideLarge} ${styles.countryColumn} `}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>City/region</span>
              </div>
            </th>
            <th
              className={`text-left ${styles.cellHideMobile} ${styles.countryColumn} ${styles.sortableColumn} ${sortColumn === 'country' ? styles.selectedColumn : ''}`}
              onClick={() => handleSort("country")}
            >
              <div className={styles.sortColumnTitle}>

                <span className={styles.sortColumnTitleText}>Country</span>
                {/* {(countryCount === 1) ? <IconSort /> : <ReverseIconSort />} */}
              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortColumn === 'millionaires' ? styles.selectedColumn : ''}
                              ${sortColumn === 'millionaires' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("millionaires")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Millionaires<br />(USD 1m+)</span>
                {(milCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.dataColumn}
                              ${sortColumn === 'centiMillionaires' ? styles.selectedColumn : ''}
                              ${sortColumn === 'centiMillionaires' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("centiMillionaires")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Centi-millionaires<br />(USD 100m+)</span>
                {(centiMilCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right   
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn}  
                              ${styles.dataColumn}
                              ${sortColumn === 'billionaires' ? styles.selectedColumn : ''}
                              ${sortColumn === 'billionaires' ? styles.displayColumnTitleDiv : ''}

              `}
              onClick={() => handleSort("billionaires")}
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Billionaires<br />(USD 1bn+)</span>
                {(bilCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>
            <th
              className={
                `text-right 
                              ${styles.cellHideMobile}
                              ${styles.sortableColumn} 
                              ${styles.progressBarColumn}
                              ${sortColumn === 'wealthGrowth' ? styles.selectedColumn : ''}
                              ${sortColumn === 'wealthGrowth' ? styles.displayColumnTitleDiv : ''}
              `}
              onClick={() => handleSort("wealthGrowth")}
              colSpan="2"
              width="35%"
            >
              <div className={styles.sortColumnTitle}>
                <span className={styles.sortColumnTitleText}>Millionaire growth (%)<br />2013 to 2023</span>
                {(wealthGrowthCount === 1) ? <IconSort /> : <ReverseIconSort />}
              </div>
            </th>

          </tr>
        </thead>
        <tbody>
          {/* {sortedData.slice(0, numOfCitiesShow).map((item, index) => ( */}
          {sortedData.map((item, index) => (
            <Fragment key={index}>
              <tr className={`${styles.contentRow}`}>
                <td className={`text-left 
                                ${styles.sortableColumn} 
                                ${sortColumn === 'country' ? styles.selectedColumn : ''}
                              `}>
                  <CountryFlag country={item.country} code={item.code} />
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'millionaires' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.millionaires)}

                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'centiMillionaires' ? styles.selectedColumn : ''}
                              `}>
                  {formatNumberWithDot(item.centiMillionaires)}

                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'billionaires' ? styles.selectedColumn : ''}
                              `}>
                  {item.billionaires > 0 ? formatNumberWithDot(item.billionaires) : '-'}

                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'wealthGrowth' ? styles.percentColumn : ''}
                                ${sortColumn === 'wealthGrowth' ? styles.selectedColumn : ''}
                              `}
                  style={{ paddingRight: 0, width: '10%' }}
                >
                  <ProgressBar
                    percentValue={item.wealthGrowth < 0 ? Math.abs(item.wealthGrowth) : 0}
                    labelText={''}
                    type="left"
                  />
                </td>
                <td className={`text-right 
                                ${styles.cellHideMobile} 
                                ${styles.sortableColumn} 
                                ${styles.cellOnMobile} 
                                ${sortColumn === 'wealthGrowth' ? styles.percentColumn : ''}
                                ${sortColumn === 'wealthGrowth' ? styles.selectedColumn : ''}
                              `}
                  style={{ paddingLeft: 0, width: '25%' }}
                >
                  <ProgressBar
                    percentValue={item.wealthGrowth > 0 ? item.wealthGrowth : 0}
                    labelText={item.wealthGrowth + "%"}
                  />
                </td>
              </tr>

            </Fragment>
          ))}

          <tr style={{ height: "40px" }}></tr>

          {totalData.map((item) => (
            <Fragment key='data-world-total' >
              <tr className={`${styles.contentRow}`} >

                <td className={`text-left 
                                ${styles.sortableColumn} 
                                ${sortColumn === 'country' ? styles.selectedColumn : ''}
                              `}
                  style={{ borderTop: "1px solid #C1C5C8" }}
                >{item.country}</td>
                <td className={`text-right
                                  ${styles.cellHideMobile}
                                  ${styles.sortableColumn}
                                  ${styles.cellOnMobile}
                                  ${styles.dataColumn}
                                  ${sortColumn === 'millionaires' ? styles.selectedColumn : ''}
                                `}
                  style={{ borderTop: "1px solid #C1C5C8" }}
                >
                  {formatNumberWithDot(item.millionaires)}
                </td>
                <td className={`text-right
                                  ${styles.cellHideMobile}
                                  ${styles.sortableColumn}
                                  ${styles.cellOnMobile}
                                  ${styles.dataColumn}
                                  ${sortColumn === 'centiMillionaires' ? styles.selectedColumn : ''}
                                `}
                  style={{ borderTop: "1px solid #C1C5C8" }}
                >
                  {formatNumberWithDot(item.centiMillionaires)}
                </td>
                <td className={`text-right
                                  ${styles.cellHideMobile}
                                  ${styles.sortableColumn}
                                  ${styles.cellOnMobile}
                                  ${styles.dataColumn}
                                  ${sortColumn === 'billionaires' ? styles.selectedColumn : ''}
                                `}
                  style={{ borderTop: "1px solid #C1C5C8" }}
                >
                  {item.billionaires > 0 ? formatNumberWithDot(item.billionaires) : '-'}
                </td>
                <td className={`text-right
                                  ${styles.cellHideMobile}
                                  ${styles.sortableColumn}
                                  ${styles.cellOnMobile}
                                  ${styles.progressBarColumn}
                                  ${sortColumn === 'wealthGrowth' ? styles.percentColumn : ''}
                                  ${sortColumn === 'wealthGrowth' ? styles.selectedColumn : ''}
                                `}
                  style={{ borderTop: "1px solid #C1C5C8", paddingRight: 0, width: '10%' }}
                >

                  <ProgressBar
                    percentValue={item.wealthGrowth < 0 ? Math.abs(item.wealthGrowth) : 0}
                    type="left"
                    labelText=""
                  />

                </td>
                <td className={`text-right
                                  ${styles.cellHideMobile}
                                  ${styles.sortableColumn}
                                  ${styles.cellOnMobile}
                                  ${styles.progressBarColumn}
                                  ${sortColumn === 'wealthGrowth' ? styles.percentColumn : ''}
                                  ${sortColumn === 'wealthGrowth' ? styles.selectedColumn : ''}
                                `}
                  style={{ borderTop: "1px solid #C1C5C8", paddingLeft: 0, width: '25%' }}
                >

                  <ProgressBar
                    percentValue={item.wealthGrowth > 0 ? item.wealthGrowth : 0}
                    labelText={formatNumberWithDot(item.wealthGrowth) + "%"}
                  />

                </td>
              </tr>
            </Fragment>
          ))}

        </tbody>
      </table>

      <div className="footer-note mt-5">
        <ul>
          <li>Figures for December 2023.</li>
          <li>Only includes individuals living in each country (residents).</li>
          <li>Millionaire figures rounded to nearest 100.</li>
        </ul>
        <p>Source: New World Wealth</p>
      </div>
    </>
  )
}

export default WealthCountries;